import { zodResolver } from '@hookform/resolvers/zod';
import { getSiteConfig } from '@shared/config';
import type { UseFormProps } from 'react-hook-form';
import { getFormSchema, type FormData } from './RegistrationSchema';

const getFormConfig = (t: (key: string) => string): UseFormProps<FormData> => ({
  resolver: zodResolver(getFormSchema(t)) as never,
  mode: 'all',
  defaultValues: {
    createAccount: {
      email: '',
      password: '',
      termsAndConditions: false,
      privacyPolicy: false,
    },
    address: {
      houseNameNumber: '',
      streetName: '',
      line2: '',
      city: '',
      state: '',
      postcode: '',
    },
    addressLookup: '',
    personalDetails: {
      firstName: '',
      lastName: '',
      dateOfBirth: {
        day: undefined,
        month: undefined,
        year: undefined,
      },
    },
    mobileNumber: {
      prefix: getSiteConfig().REGISTRATION.defaultPhonePrefix,
      number: '',
    },
    // TODO: not part of Wave 0, because the Core Domain API is not yet implemented
    // otpValidation: {
    //   otp: '',
    // },
    productPreferences: [],
    channelPreferences: [],
    depositLimits: {
      period: getSiteConfig().REGISTRATION.isDailyFirstPeriodOrder ? { label: t('buttons.daily'), value: 2 } : { label: t('buttons.monthly'), value: 0 },
      amount: undefined,
    },
  },
});

export { getFormConfig, getFormSchema };
export type { FormData };
